module.exports = __webpack_public_path__ + "img/Phone_Frame.c64bb8b1.png";